var validModifiers = ['alt', 'ctrl', 'meta', 'shift', 'cmd'];

export { validModifiers as default };
